import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=7a28831c&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=7a28831c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28831c",
  null
  
)

export default component.exports